import { VinhubChat, VinhubMessage } from './vinhub.model';

export class VinhubChatResponse {
  page: number = 0;
  pageSize: number = 3;
  total: number;
  data: VinhubChat[];
  totalPages: number;
}

export class VinhubChatMessageResponse {
  page: number = 0;
  pageSize: number = 3;
  total: number;
  data: VinhubMessage[];
  totalPages: number;
}

export class VinhubChatHistoryResponse {
  chatId: number;
  userId: string;
  status: string;
  startDate: string;
  endDate: string;
  s3Url: string;
}
